import KmFormItem from '../form/form-item'
KmFormItem.install = function (vue) {
  vue.component(KmFormItem.name, KmFormItem)
}
export default KmFormItem



// WEBPACK FOOTER //
// ./src/ui/components/form-item/index.js